import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import SBLWelcomePage from "./dashboard/sbl";
import RNDWelcomePage from "./dashboard/rnd";
import { AppPrimaryButton } from "shared/components/AppComponents";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthActions } from "state/auth/Action";
import { useProgress } from "context/ProgressProvider";

type IndexPageProps = {
  path?: string | null;
};

const IndexPage: React.FC<IndexPageProps> = ({ path }) => {
  const navigate = useNavigate();
  const [selectedLoan, setSelectedLoan] = useState("");
  const authInfo = useSelector((state: any) => state.authState);
  const dispatch = useDispatch();
  const location = useLocation();
  const { isBroker } = useProgress();

  const handleLogout = () => {
    const isSblApplyRoute = location.pathname.startsWith("/sbl");

    const resetStorage = new Promise((resolve, reject) => {
      dispatch(AuthActions.resetStore({}));
      resolve(true);
    });

    resetStorage.then(() => {
      if (isBroker) {
        navigate("/broker");
      } else {
        if (isSblApplyRoute) {
          navigate("/sbl");
        } else {
          navigate("/rnd");
        }
      }
    });
  };

  useEffect(() => {
    if (!authInfo.selectedLoan && authInfo.hasMultipleLoans) {
      handleLogout();
      return;
    }
  }, []);

  return (
    <Box className="app-container">
      {path === "sbl" && <SBLWelcomePage />}
      {path === "rnd" && <RNDWelcomePage />}
      {!path && (
        <Box
          sx={{
            width: "100%",
            textAlign: "center",
            minHeight: "100vh",
            alignContent: "center",
          }}
        >
          {" "}
          <FormControl>
            <Typography>Please select the loan type:</Typography>
            <RadioGroup
              aria-labelledby="loantype-radio-buttons-group-label"
              value={selectedLoan}
              onChange={(e) => setSelectedLoan(e.target.value)}
              name="radio-buttons-group"
            >
              <FormControlLabel
                value="sbl"
                control={<Radio />}
                label="Secured Business Loan"
              />
              <FormControlLabel
                value="rnd"
                control={<Radio />}
                label="R&D Loan"
              />
            </RadioGroup>
            <AppPrimaryButton
              title="Continue"
              onClick={() => navigate(`/${selectedLoan}`)}
              disabled={!selectedLoan}
            />
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default IndexPage;
